import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Settings } from '../model';
import { actions, useSelector } from '../store';
import Toggle from './Toggle';
import css from './WebRtcClientConfigurator.module.scss';

export default function WebRtcClientConfigurator() {
  const {endpoint, line, settings} = useSelector(s => s.janus)
  const dispatch = useDispatch()

  const [settingsState, setSettingsState] = useState(settings)

  function commitConfiguration() {
    dispatch(actions.configureEndpoint(settingsState))
  }

  useEffect(() => {
    setSettingsState(settings)
  }, [settings])

  function input<T extends keyof Settings>(prop: T, label: string, type: string = 'text') {
    return <label>{label}<input type={type} value={settingsState[prop]} onChange={e => {
      const value = e.currentTarget.value
      setSettingsState(s => ({ ...s, [prop]: value }))
    }} /></label>
  }

  return <div>
    <div className={css.webRtcClientConfiguratorContainer}>
      <h2>WebRTC Softphone Configuration</h2>
      {<div className={css.status}>Endpoint Status: {endpoint.status}</div>}
      {endpoint.statusError && <div className={css.error}>{endpoint.statusError}</div>}
      {line.statusError && <div className={css.error}>{line.statusError}</div>}
      {<div className={css.status}>Line Status: {line.status}</div>}

      {input('janus', 'Janus Server')}
      {input('sipRealm', 'Sip Realm')}
      {input('serverUsername', 'Server Username')}
      {input('serverPassword', 'Server Password')}
      {input('turnServer', 'Turn Server')}
      {input('turnServerUdpPort', 'Turn UDP Port', 'number')}
      {input('turnServerTcpPort', 'Turn TCP Port', 'number')}
      {input('turnUsername', 'Turn Username')}
      {input('turnPassword', 'Turn Password')}

      <div className={css.applyContainer}>
        <button onClick={() => commitConfiguration()}>Apply</button>
      </div>
    </div>
  </div>
}
